module.exports = __WEBPACK_EXTERNAL_MODULE_3__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"localforage","commonjs2":"localforage","amd":"localforage","root":"localforage"}
// module id = 3
// module chunks = 0 1